angular.module('impactx.list').component('ixListPagination', {
        bindings: {
            currentPage: '<',
            rowsPerPage: '<',
            maxPageNumber: '<',
            maxRowNumber: '<',
            onPageChange: '&',
            listId: '<',
            showRowsPerPage: "<"
        },
        controller: 'ListPaginationCtrl',
        require: {
            smartTableCtrl: '^^stTable'
        },
        templateUrl: 'shared/list/templates/list-pagination.html'
    }
);